import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import backicon from '../../../../Assets/icons/backIcon.svg';
import './CreateOrder.scss';
import axiosInstance from '../../../services/api/API';
import Swal from 'sweetalert2';
import ROUTES_NAVIGATION from '../../../../routes/routes';
import PlusIcon from '../../../../Assets/icons/plus-circle.svg';
import CloseIcon from '../../../../Assets/icons/trash.svg';
import DynamicForm from '../../../customformComponent/customForm/DynamicForm';
import { FaImage } from 'react-icons/fa';

const CreateNewOrder = () => {
  const [formData, setFormData] = useState({});
  const [items, setItems] = useState([
    {
      itemType: 'V',
      variant: '',
      color: '',
      warranty: '',
      extwarranty: '',
      quantity: '',
      baseprice: '',
      tax: '',
      totalAmount: '',
      category: '',
    },
  ]);
  const [validationErrors, setValidationErrors] = useState({});
  const [errors, setErrors] = useState({});
  const [selectedItemType, setSelectedItemType] = useState('V');
  const [variantOptions, setVariantOptions] = useState([]);
  const [extWarrantyOptions, setextWarrantyOptions] = useState([]);

  const [itemCategoryOption, setItemcategoryOptions] = useState([]);

  const [loading, setLoading] = useState([]);
  const [accessoryOptions, setaccessoryOptions] = useState([]);

  const [variantIdVal, setVariantIdVal] = useState();

  const [variantBaseImage, setVariantBaseImage] = useState('');

  const [itemBaseImage, setItemBaseImage] = useState('');

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');

  const handleImageClick = (image) => {
    if (image) {
      setModalImage(image); // Set the image to display
      setIsModalOpen(true); // Open the modal
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const navigate = useNavigate();
  const authToken = localStorage.getItem('authToken');

  useEffect(() => {
    fetchVariantOptions();
  }, []);
  const POInputs = [
    // {
    //   name: "pono",
    //   label: "PO No.",
    //   placeholder: "PO No.",
    //   type: "text",
    //   disabled:true,
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "podate",
    //   label: "PO Date.",
    //   placeholder: "PO Date",
    //   type: "date",
    //  disabled:true,
    //   gridClass: "col-lg-4",
    // },
    // {
    //   name: "status",
    //   label: "Status",
    //   placeholder: "Status",
    //   type: "text",
    //  disabled:true,
    //   gridClass: "col-lg-4",
    // },
  ];

  useEffect(() => {
    setFormData({ ...formData, podate: Date.now(), status: 'Pending' });
  }, []);
  useEffect(() => {
    console.log('selectedItemType', selectedItemType);

    // Clear all relevant data when selectedItemType changes
    setItems((prevItems) =>
      prevItems.map((item) => ({
        ...item,
        // variant: "",
        // color: "",
        // warranty: "",
        // // extwarranty: "",
        // quantity: "" ,
        // accessory:"",
        // baseprice:"",
        // tax:"",
        // totalAmount:"",
      })),
    );
    console.log('orderitems', items);

    const itemtypeid = items[0].itemType == 'A' ? 2 : 1;
    if (items[0].itemType == 'A' || items[0].itemType == 'S') {
      fetchItemOptions(itemtypeid, variantIdVal);
    }
  }, [items[0].itemType, variantIdVal]);

  useEffect(() => {
    fetchItemOptions();
  }, [items]);

  useEffect(() => {
    console.log('Items updated:', items[0].itemType);
  }, [items]);

  useEffect(() => {
    fetchItemCategoryOptions();
  }, [items]);

  const fetchItemCategoryOptions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/partcategory/ddlpartcategory',
        {
          // itemtype_id: itemtypeid,
          // variant_id:variantIdVal,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setItemcategoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  const fetchItemOptions = async (itemtypeid, variantIdVal, category_id) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitem',
        {
          itemtype_id: itemtypeid,
          variant_id: variantIdVal,
          category_id: category_id,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setaccessoryOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };

  const fetchVariantOptions = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariant',
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const options = response.data.data.data?.map((variant) => ({
        label: variant.NAME,
        value: variant.ID,
      }));
      setVariantOptions(options);
    } catch (error) {
      console.error('Error fetching variant options:', error);
    }
  };
  const fetchItemBasedDetails = async (variantId, index) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/item/ddlitembase',
        { item_id: variantId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const variantData = response?.data?.data?.data[0];

      const updatedItems = [...items];
      updatedItems[index] = {
        ...updatedItems[index],
        color: variantData?.color_name || '',
        warranty: variantData?.warranty_name || '',
        // extwarranty: variantData?.ext_warranty || "",
        baseprice: variantData?.purchase_price || '',
        tax: variantData?.tax_percent || '',
        itemBaseImage:
          variantData?.item_image || 'https://via.placeholder.com/150', // Set the image
      };

      setItems(updatedItems);

      const itemImage = variantData?.item_image;
      console.log(itemImage, 'itemImage');
      setItemBaseImage(itemImage);
    } catch (error) {
      console.error('Error fetching variant-based details:', error);
    }
  };
  // Fetch variant-based details when a variant is selected
  // const fetchVariantBasedDetails = async (variantId, index) => {
  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const response = await axiosInstance.post(
  //       "/variant/ddlvariantbasedetails",
  //       { variant_id: variantId },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     const variantData = response?.data?.data[0];

  //     console.log(variantData?.variant_id, "variantIdData")
  //     setVariantIdVal(variantData?.variant_id)

  //     const variantBaseImage = variantData?.variant_image
  //     setVariantBaseImage(variantBaseImage)

  //     const updatedItems = [...items];
  //     updatedItems[index] = {
  //       ...updatedItems[index],
  //       color: variantData?.color_name || "",
  //       warranty: variantData?.warranty_name || "",
  //       extwarranty: variantData?.ext_warranty || "",
  //       baseprice:variantData?.exshowroom_price || "",
  //       tax:variantData?.tax_percent || "",
  //     };
  //     setItems(updatedItems);
  //   } catch (error) {
  //     console.error("Error fetching variant-based details:", error);
  //   }
  // };

  const fetchVariantBasedDetails = async (variantId, index) => {
    try {
      const token = localStorage.getItem('authToken');
      const response = await axiosInstance.post(
        '/variant/ddlvariantbasedetails',
        { variant_id: variantId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const variantData = response?.data?.data[0];

      if (!variantData) {
        console.error('No variant data found');
        return;
      }

      const updatedItems = [...items];
      updatedItems[index] = {
        ...updatedItems[index],
        color: variantData?.color_name || '',
        warranty: variantData?.warranty_name || '',
        extwarranty: variantData?.ext_warranty || '',
        baseprice: variantData?.exshowroom_price || '',
        tax: variantData?.tax_percent || '',
        variantBaseImage:
          variantData?.variant_image || 'https://via.placeholder.com/150', // Set the image
      };

      setItems(updatedItems); // Update the entire items array with the new data
    } catch (error) {
      console.error('Error fetching variant-based details:', error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    items.forEach((item, index) => {
      // Validate Vehicle type fields
      if (selectedItemType === 'Vehicle' && !item.variant) {
        newErrors[`variant_${index}`] = 'Please select a variant';
      }
      if (!item.quantity || item.quantity <= 0) {
        newErrors[`quantity_${index}`] = 'Quantity must be greater than zero';
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  //   const handleItemChange = async (index, field, value) => {
  //     const updatedItems = [...items];
  //     updatedItems[index][field] = value;

  //     const quantity = parseFloat(updatedItems[index].quantity || 0);
  // const basePrice = parseFloat(updatedItems[index].baseprice || 0);
  // const tax = parseFloat(updatedItems[index].tax || 0);

  // if (quantity && basePrice && tax) {
  //   const taxMultiplier = 1 + tax / 100; // Convert tax percentage to multiplier
  //   updatedItems[index].totalAmount = (quantity * basePrice * taxMultiplier).toFixed(2);
  // } else {
  //   updatedItems[index].totalAmount = ""; // Clear total amount if inputs are incomplete
  // }

  //     console.log("updatedItems",updatedItems);

  //     setItems(updatedItems);
  //     setErrors((prevErrors) => ({
  //       ...prevErrors,
  //       [`${field}_${index}`]: "",
  //     }));

  //     // Fetch details if the variant or accessory is selected
  //     if (field === "variant" && value) {
  //           fetchVariantBasedDetails(value, index) ;
  //           // fetchExtWarrantyOptions(value, index);
  //         }
  //         if (field === "accessory" && value) {
  //           fetchItemBasedDetails(value, index);
  //           // fetchExtWarrantyOptions(value, index);
  //         }

  //         if (field === "spare parts" && value) {
  //           fetchItemBasedDetails(value, index);
  //           // fetchExtWarrantyOptions(value, index);
  //         }
  //   };

  // useEffect(() => {
  //   console.log("Updated items:", items);
  // }, [items,fetchExtWarrantyOptions])
  // Add new item row
  // const addItem = () => {
  //   setItems([
  //     ...items,
  //     { variant: "", color: "", warranty: "", extwarranty: "", quantity: "", baseprice:"" },
  //   ]);
  // };

  // const addItem = () => {
  //   setItems([
  //     ...items,
  //     { itemType: "", variant: "", color: "", warranty: "", quantity: "", baseprice: "", tax: "", totalAmount: "" },
  //   ]);
  // };

  const handleItemChange = async (index, field, value) => {
    const updatedItems = [...items];
    updatedItems[index][field] = value;

    const quantity = parseFloat(updatedItems[index].quantity || 0);
    const basePrice = parseFloat(updatedItems[index].baseprice || 0);
    const tax = parseFloat(updatedItems[index].tax || 0);

    if (quantity && basePrice && tax) {
      const taxMultiplier = 1 + tax / 100; // Convert tax percentage to multiplier
      updatedItems[index].totalAmount = (
        quantity *
        basePrice *
        taxMultiplier
      ).toFixed(2);
    } else {
      updatedItems[index].totalAmount = ''; // Clear total amount if inputs are incomplete
    }

    setItems(updatedItems);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [`${field}_${index}`]: '',
    }));

    if (field === 'variant' && value) {
      const imageURL = await fetchVariantBasedDetails(value); // Fetch the image URL for the selected variant
      updatedItems[index].variantBaseImage = imageURL; // Update the image URL for this specific item
    }

    // if (field === "accessory" && value){
    //   const imageURL = await fetchItemBasedDetails(value); // Fetch the image URL for the selected variant
    //   updatedItems[index].itemBaseImage = imageURL; // Update the image URL for this specific item
    // }

    if (field === 'accessory') {
      const imageURL = await fetchItemBasedDetails(value); // Fetch the image URL for the selected variant
      updatedItems[index].itemBaseImage = imageURL; // Update the image URL for this specific item
    }

    // Fetch details if the variant, accessory, or spare part is selected
    if (field === 'variant' && value) {
      fetchVariantBasedDetails(value, index);
    }
    if ((field === 'accessory' || field === 'spare parts') && value) {
      fetchItemBasedDetails(value, index);
    }
  };

  const addItem = () => {
    setItems([
      ...items,
      {
        itemType: 'V', // Default to "Vehicle"
        variant: '',
        color: '',
        warranty: '',
        extwarranty: '',
        quantity: '',
        baseprice: '',
        tax: '',
        totalAmount: '',
      },
    ]);
  };

  const removeItem = (index) => {
    const updatedItems = [...items];
    updatedItems.splice(index, 1);
    setItems(updatedItems);
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      Swal.fire({
        title: 'Validation Error',
        text: 'Please correct the errors before submitting.',
        icon: 'error',
        confirmButtonText: 'OK',
      });
      return;
    }
    const orderarray = items.map((item) => {
      let payloadItem = {
        quantity: item.quantity,
        itemtype: item.itemType,
        // extended_warranty_id: item.extwarranty || null,
      };

      if (item.itemType === 'V') {
        // payloadItem.itemtype = "V";
        payloadItem.variant_id = item.variant;
      } else if (item.itemType === 'A') {
        // payloadItem.itemtype = "A";
        payloadItem.item_id = item.accessory;
      } else if (item.itemType === 'S') {
        // payloadItem.itemtype = "S";
        payloadItem.item_id = item.accessory;
      }

      return payloadItem;
    });

    // Constructing the final payload
    const payload = { orderarray };

    console.log('Payload to be sent:', payload);

    // Confirmation using SweetAlert
    Swal.fire({
      title: 'Are you sure?',
      text: 'Do you want to create this order?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);

          // API call to create a purchase order
          const response = await axiosInstance.post(
            '/purchaseorder/create',
            payload,
            {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${authToken}`,
              },
            },
          );

          if (response.status === 200) {
            Swal.fire({
              title: 'Success',
              text: 'Purchase Order created successfully!',
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              navigate('/manage-sales/manage-order');
              // /manage-order
            });
          }
        } catch (error) {
          console.error('Error adding dealer:', error);
          const errorMessage =
            error.response?.data?.message ||
            'An error occurred while processing your request.';
          Swal.fire({
            title: 'Error',
            text: errorMessage,
            icon: 'error',
            confirmButtonText: 'OK',
          });
        } finally {
          setLoading(false);
        }
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire({
          title: 'Cancelled',
          text: 'The purchase order was not created.',
          icon: 'info',
          confirmButtonText: 'OK',
        });
        setLoading(false);
      }
    });
  };
  const handleFormSubmit = () => {};

  const customStyles = {
    control: (provided) => ({
      ...provided,
      borderColor: '#ccc',
      boxShadow: 'none',
      borderRadius: '10px',

      '&:hover': {
        borderColor: '#888',
      },
    }),
    valueContainer: (provided) => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
      height: '50px',
      width: '200px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '5px',
      borderColor: '#ccc',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#7BD755'
        : state.isFocused
          ? '#fff'
          : null,
      // color: state.isSelected || state.isFocused ? "white" : "black",
      '&:hover': {
        backgroundColor: '#f2fcf0',
        color: '#000',
      },
    }),
  };

  const itemTypeOptions = [
    { value: 'V', label: 'Vehicle' },
    { value: 'A', label: 'Accessory' },
    { value: 'S', label: 'Spare Part' },
  ];

  return (
    <>
      <div>
        <div
          style={{ paddingTop: '20px', borderBottom: '1px solid lightgray' }}
          className="header-container"
        >
          <div className="backbutton mt-2 mb-2" >
            <img src={backicon} alt="back" onClick={() => navigate(-1)}/>
            <span className="backbtntitle">New Purchase Order</span>
          </div>
          <div>
            <button className="submit-btn" onClick={handleSubmit}>
              Generate Order
            </button>
          </div>
        </div>
        <DynamicForm
          formConfig={POInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />

        <div
          className="PO-form-container"
          style={{ paddingLeft: '47px', marginTop: '50px', paddingTop: '15px' }}
        >
          <p
            style={{ color: '#000', paddingBottom: '12px', paddingTop: '12px' }}
            className="section-title"
          >
            Add Vehicle / Spare Part / Accessory
          </p>

          {items?.map((item, index) => (
            <div
              key={index}
              className="item-row row"
              style={{ margin: 0, justifyContent: 'flexStart' }}
            >
              {/* Conditional rendering based on the selected type */}
              {item.itemType === 'V' && (
                <>
                  {/* First input field (Variant) */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={itemTypeOptions}
                        value={itemTypeOptions.find(
                          (option) => option.value === item.itemType,
                        )}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'itemType',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Item Type..."
                        isClearable
                        styles={customStyles}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={variantOptions}
                        value={variantOptions?.find(
                          (option) => option?.value === item?.variant,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'variant',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Variant..."
                        isClearable
                        required
                      />
                      {errors[`variant_${index}`] && (
                        <span className="order-error">
                          {errors[`variant_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Second input field (Color) */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Color"
                        value={item?.color}
                        disabled
                        className="form-control"
                      />
                      {errors[`color_${index}`] && (
                        <span className="order-error">
                          {errors[`color_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Third input field (Warranty) */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Warranty"
                        value={item?.warranty}
                        disabled
                        className="form-control"
                      />
                    </div>
                  </div>

                  {/* Fifth input field (Quantity) */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Request Qty."
                        value={item.quantity}
                        onChange={(e) =>
                          handleItemChange(index, 'quantity', e.target.value)
                        }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Sixth input field */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Base Price"
                        value={item.baseprice}
                        // onChange={(e) =>
                        //   handleItemChange(index, "quantity", e.target.value)
                        // }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* seventh input field  */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Tax"
                        value={item.tax}
                        // onChange={(e) =>
                        //   handleItemChange(index, "quantity", e.target.value)
                        // }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* eigth input field  */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Total Amount"
                        value={item.totalAmount}
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Action Icons (Add/Remove) */}
                  <div
                    className="col-12 col-lg-1 d-flex align-items-center"
                    style={{ margin: 0, marginBottom: 15 }}
                  >
                    {/* Add Icon (for last item only) */}
                    {index === items.length - 1 && (
                      <img
                        src={PlusIcon}
                        height={20}
                        width={20}
                        onClick={addItem}
                        alt="Add"
                        className="action-icon"
                      />
                    )}

                    {/* Remove Icon (for all but last item) */}
                    {items.length > 1 && (
                      <img
                        src={CloseIcon}
                        height={20}
                        width={20}
                        onClick={() => removeItem(index)}
                        alt="Remove"
                        className="action-icon"
                        style={{ marginLeft: '12px' }}
                      />
                    )}
                    {/* <FaImage size={25} style={{marginLeft:"20px"}} /> */}
                    {/* <img src={variantBaseImage} alt="Image" height={25} width={25}  /> */}
                    <img
                      src={
                        item.variantBaseImage ||
                        'https://via.placeholder.com/150'
                      }
                      alt="Variant Image"
                      height={50}
                      width={50}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/150'; // Fallback image
                      }}
                      style={{
                        marginLeft: '20px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleImageClick(item.variantBaseImage)}
                    />
                  </div>
                </>
              )}

              {/* {isModalOpen && (
    <div 
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 1000,
        opacity: isModalOpen ? 1 : 0,
        transform: isModalOpen ? "scale(1)" : "scale(0.9)",
        transition: "all 0.3s ease-in-out",
        
      }}
      onClick={closeModal}
    >
      <img 
        src={variantBaseImage} 
        alt="Zoomed Variant Image" 
        style={{
          maxHeight: "90%",
          maxWidth: "90%",
          borderRadius: "10px",
        }} 
      />
    </div>
  )} */}

              {isModalOpen && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000,
                    opacity: isModalOpen ? 1 : 0,
                    transform: isModalOpen ? 'scale(1)' : 'scale(0.9)',
                    transition: 'all 0.3s ease-in-out',
                  }}
                  onClick={closeModal}
                >
                  <img
                    src={modalImage}
                    alt="Zoomed Image"
                    style={{
                      maxHeight: '90%',
                      maxWidth: '90%',
                      borderRadius: '10px',
                    }}
                  />
                </div>
              )}

              {item.itemType === 'A' && (
                <>
                  {/* First input field (Variant) */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={itemTypeOptions}
                        value={itemTypeOptions.find(
                          (option) => option.value === item.itemType,
                        )}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'itemType',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Item Type..."
                        isClearable
                        styles={customStyles}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={variantOptions}
                        value={variantOptions?.find(
                          (option) => option?.value === item?.variant,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'variant',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Variant..."
                        isClearable
                        required
                      />
                      {errors[`variant_${index}`] && (
                        <span className="order-error">
                          {errors[`variant_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={itemCategoryOption}
                        value={itemCategoryOption?.find(
                          (option) => option?.value === item?.category,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'category',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Category"
                        isClearable
                        required
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={accessoryOptions}
                        value={accessoryOptions?.find(
                          (option) => option?.value === item?.accessory,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) => {
                          handleItemChange(
                            index,
                            'accessory',
                            selectedOption?.value,
                          );
                          fetchItemOptions(selectedOption?.value);
                        }}
                        placeholder="Select Item"
                        isClearable
                        required
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Warranty input */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Warranty"
                        value={item?.warranty}
                        disabled
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Color"
                        value={item?.color}
                        disabled
                        className="form-control"
                      />
                      {errors[`color_${index}`] && (
                        <span className="order-error">
                          {errors[`color_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Quantity input */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Request Qty."
                        value={item.quantity}
                        onChange={(e) =>
                          handleItemChange(index, 'quantity', e.target.value)
                        }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Sixth input field */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Base Price"
                        value={item.baseprice}
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* seventh input field  */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Tax"
                        value={item.tax}
                        // onChange={(e) =>
                        //   handleItemChange(index, "quantity", e.target.value)
                        // }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* eigth input field  */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Total Amount"
                        value={item.totalAmount}
                        onChange={(e) =>
                          handleItemChange(index, 'quantity', e.target.value)
                        }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Action Icons */}
                  <div
                    className="col-12 col-lg-1 d-flex align-items-center"
                    style={{ margin: 0, marginBottom: 15 }}
                  >
                    {index === items.length - 1 && (
                      <img
                        src={PlusIcon}
                        height={20}
                        width={20}
                        onClick={addItem}
                        alt="Add"
                        className="action-icon"
                      />
                    )}
                    {items.length > 1 && (
                      <img
                        src={CloseIcon}
                        height={20}
                        width={20}
                        onClick={() => removeItem(index)}
                        alt="Remove"
                        className="action-icon"
                        style={{ marginLeft: '10px' }}
                      />
                    )}
                    <img
                      src={
                        item.itemBaseImage || 'https://via.placeholder.com/150'
                      }
                      alt={`Item Image ${index}`}
                      height={50}
                      width={50}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/150'; // Fallback image
                      }}
                      style={{
                        marginLeft: '20px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleImageClick(item.itemBaseImage)}
                    />
                  </div>
                </>
              )}

              {item.itemType === 'S' && (
                <>
                  {/* First input field (Variant) */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={itemTypeOptions}
                        value={itemTypeOptions.find(
                          (option) => option.value === item.itemType,
                        )}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'itemType',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Item Type..."
                        isClearable
                        styles={customStyles}
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={variantOptions}
                        value={variantOptions?.find(
                          (option) => option?.value === item?.variant,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'variant',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Variant..."
                        isClearable
                        required
                      />
                      {errors[`variant_${index}`] && (
                        <span className="order-error">
                          {errors[`variant_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={itemCategoryOption}
                        value={itemCategoryOption?.find(
                          (option) => option?.value === item?.category,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'category',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Category"
                        isClearable
                        required
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <Select
                        options={accessoryOptions}
                        value={accessoryOptions?.find(
                          (option) => option?.value === item?.accessory,
                        )}
                        styles={customStyles}
                        onChange={(selectedOption) =>
                          handleItemChange(
                            index,
                            'accessory',
                            selectedOption?.value,
                          )
                        }
                        placeholder="Select Item"
                        isClearable
                        required
                      />
                    </div>
                  </div>

                  {/* Warranty input */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Warranty"
                        value={item?.warranty}
                        disabled
                        className="form-control"
                      />
                    </div>
                  </div>

                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Color"
                        value={item?.color}
                        disabled
                        className="form-control"
                      />
                      {errors[`color_${index}`] && (
                        <span className="order-error">
                          {errors[`color_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Extended Warranty select */}
                  {/* {item?.extWarrantyOptions?.length > 0 &&   <div className="col-12 col-lg-2">
          <div className="input-wrapper">
            <Select
              options={extWarrantyOptions}
              value={extWarrantyOptions?.find((option) => option?.value === item?.extwarranty)}
              styles={customStyles}
              onChange={(selectedOption) =>
                handleItemChange(index, "extwarranty", selectedOption?.value)
              }
              placeholder="Select..."
              isClearable
              required
            />
            {errors[`extwarranty_${index}`] && (
              <span className="order-error">{errors[`extwarranty_${index}`]}</span>
            )}
          </div>
        </div> } */}

                  {/* Quantity input */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Request Qty."
                        value={item.quantity}
                        onChange={(e) =>
                          handleItemChange(index, 'quantity', e.target.value)
                        }
                        required
                        className="form-control"
                      />
                    </div>
                  </div>

                  {/* Sixth input field */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Base Price"
                        value={item.baseprice}
                        // onChange={(e) =>
                        //   handleItemChange(index, "quantity", e.target.value)
                        // }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* seventh input field  */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="text"
                        placeholder="Tax"
                        value={item.tax}
                        // onChange={(e) =>
                        //   handleItemChange(index, "quantity", e.target.value)
                        // }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* eigth input field  */}
                  <div className="col-12 col-lg-2">
                    <div className="input-wrapper">
                      <input
                        type="number"
                        placeholder="Total Amount"
                        value={item.totalAmount}
                        onChange={(e) =>
                          handleItemChange(index, 'quantity', e.target.value)
                        }
                        required
                        className="form-control"
                      />
                      {errors[`quantity_${index}`] && (
                        <span className="order-error">
                          {errors[`quantity_${index}`]}
                        </span>
                      )}
                    </div>
                  </div>

                  {/* Action Icons */}
                  <div
                    className="col-12 col-lg-1 d-flex align-items-center"
                    style={{ margin: 0, marginBottom: 15 }}
                  >
                    {index === items.length - 1 && (
                      <img
                        src={PlusIcon}
                        height={20}
                        width={20}
                        onClick={addItem}
                        alt="Add"
                        className="action-icon"
                      />
                    )}
                    {items.length > 1 && (
                      <img
                        src={CloseIcon}
                        height={20}
                        width={20}
                        onClick={() => removeItem(index)}
                        alt="Remove"
                        className="action-icon"
                        style={{ marginLeft: '10px' }}
                      />
                    )}
                    <img
                      src={
                        item.itemBaseImage || 'https://via.placeholder.com/150'
                      }
                      alt={`Item Image ${index}`}
                      height={50}
                      width={50}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://via.placeholder.com/150'; // Fallback image
                      }}
                      style={{
                        marginLeft: '20px',
                        borderRadius: '10px',
                        cursor: 'pointer',
                      }}
                      onClick={() => handleImageClick(item.itemBaseImage)}
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CreateNewOrder;
